export const isValidHourlyOption = (scheduleEntry, option) => {
  if (scheduleEntry.startTime.slice(scheduleEntry.startTime.length - 5, scheduleEntry.startTime.length) === '00:00') {
    return option.num % 100 === 0
  }
  return option.num % 100 !== 0
}
